<template>
  <div>
    <slot v-bind:open="open" />

    <Modal :show="showTeams" @closeModal="close">
      <assign-modal :date="date" @assign="onAssign" />
    </Modal>
  </div>
</template>
<script>
import AssignModal from "../../../MasterList/AssignModal.vue";
import Modal from "../../../../../Shared/Modal.vue";

export default {
  name: 'TeamSelectModal',
  components: {Modal, AssignModal},

  props: {
    date: null,
  },

  data() {
    return {
      showTeams: false,
    }
  },

  methods: {
    open() {
      this.showTeams = true
    },
    close() {
      this.showTeams = false
    },

    onAssign(team) {
      this.$emit('assign', {
        id: team.team_id,
        name: team.name
      })
      this.$nextTick(() => {
        this.close()
      })
    }
  }
}
</script>
